import { CadastroInsumoFormValues } from "../../../assets/interfaces/Agricultor";

export const initialValues: CadastroInsumoFormValues = {
  descricao: "",
  id_categoria: "0",
  unidade: "",
  custo_unitario: 0,
};
